export default [

    {
        question: 'Как занятия в клубе помогут моему ребёнку в будущем?',
        answer: 'Мы даем только конкретные, современные знания без лишней воды. Увлеченный ребенок может определиться с профессией и начать зарабатывать уже в школе.'
    },
    {
        question: "А много времени надо потратить, чтобы стать программистом?",
        answer: "Если вы чем-то увлечены время летит незаметно. 90% процентов программистов - самоучки. Чтобы чего-то достигнуть надо постараться.",
    },
    {
        question: 'Программисты получают 100 тыс. рублей в месяц?',
        answer: 'Да, в основном программисты получают 100-200 тыс. рублей, а хорошие специалисты и более.'
    },
    {
        question: 'Почему вы учите именно дизайну и программированию?',
        answer: ' Любой сайт, приложение или игра состоит из внешнего вида и кода, мы хотим чтобы дети дизайнеры объединялись с программистами для создания чего-то интересного.'
    },
    {
        question: 'Какое оборудование нужно для программирования и дизайна?',
        answer: 'Подойдёт самый обычный компьютер, на котором запускаются стандартные программы.'
    },
    {
        question: 'Нужна ли специальная подготовка для занятий?',
        answer: 'Нет, но в данном случае важную роль играет интерес и мотивация, поэтому все зависит от вашего ребенка'
    },
    {
        question: 'Помогут ли занятия в клубе в сдаче ЕГЭ?',
        answer: 'В какой-то мере, но школьная информатика специфическая дисциплина, оторванная от практики.'
    },
    {
        question: 'Даете ли вы сертификат, аттестат?',
        answer: 'Нет, мы не учебное заведение, мы клуб. Наша задача увлечь, заинтересовать, показать красоту и разнообразие IT мира.'
    }

]
